
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 12C2 9.88942 2.66778 7.83296 3.90774 6.12502C5.1477 4.41709 6.89625 3.14527 8.90307 2.49163C10.9099 1.838 13.0721 1.83608 15.08 2.48614C17.088 3.13621 18.8388 4.40492 20.0818 6.11065M20.0818 6.11065V3M20.0818 6.11065H17","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 12C2 9.88942 2.66778 7.83296 3.90774 6.12502C5.1477 4.41709 6.89625 3.14527 8.90307 2.49163C10.9099 1.838 13.0721 1.83608 15.08 2.48614C17.088 3.13621 18.8388 4.40492 20.0818 6.11065M20.0818 6.11065V3M20.0818 6.11065H17","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.0818 12C22.0818 14.1106 21.414 16.167 20.174 17.875C18.9341 19.5829 17.1855 20.8547 15.1787 21.5084C13.1719 22.162 11.0097 22.1639 9.00176 21.5139C6.99379 20.8638 5.24298 19.5951 3.99998 17.8893M3.99998 17.8893L3.99998 21M3.99998 17.8893L7.08179 17.8893","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    